import { render, staticRenderFns } from "./items-grid.vue?vue&type=template&id=0642c394&scoped=true&"
import script from "./items-grid.vue?vue&type=script&lang=js&"
export * from "./items-grid.vue?vue&type=script&lang=js&"
import style0 from "./items-grid.vue?vue&type=style&index=0&id=0642c394&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0642c394",
  null
  
)

export default component.exports